import { NgModule, isDevMode } from '@angular/core';
import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppModule } from './app.module.js';
import { RootComponent } from './root.component.js';

@NgModule({
	declarations: [],
	imports: [
		AppModule,
		BrowserAnimationsModule,
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: !isDevMode(),
			// Register the ServiceWorker as soon as the application is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000'
		})
	],
	bootstrap: [RootComponent],
	// Using withNoHttpTransferCache because of domain mismatch and because
	// the HttpService uses custom implementation of transfer state
	providers: [provideClientHydration(withNoHttpTransferCache())]
})
export class AppBrowserModule {}
